import { useIntl } from "react-intl";

import { useSearchParameters } from "@/components/signup/hooks";

import {
    experiments,
    getExperiment
} from "../../../../../../../../utils/experiment";
import { useConfirmationPage } from "../../hooks/use-confirmation-page";
import {
    getProductQueryParamTeamType,
    USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT
} from "../../models/user-segmentation";

import {
    SampleProjectConfigurations,
    defaultSampleProjectConfiguration,
    KANBAN_PROJECT_DEFAULTS
} from "./types";

const getSampleProjectConfiguration = (teamType: string) => {
    const jsmGrowth220JsmJpdWacSignupCohort = getExperiment(
        experiments.jsmGrowth220JsmJpdWacSignup
    );
    if (
        teamType === USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT &&
        jsmGrowth220JsmJpdWacSignupCohort.type === "enrolled" &&
        jsmGrowth220JsmJpdWacSignupCohort.value === "variation"
    ) {
        return defaultSampleProjectConfiguration;
    }
    return (
        SampleProjectConfigurations[teamType] ??
        defaultSampleProjectConfiguration
    );
};

export const useSampleProjectConfiguration = () => {
    const intl = useIntl();
    const {
        userSegmentationContext: { selectedTeamType = "" }
    } = useConfirmationPage();
    const { teamType: queryParamTeamType } = useSearchParameters();

    const teamType = selectedTeamType ?? queryParamTeamType;
    const teamTypeShorthand = getProductQueryParamTeamType(teamType);

    const config = getSampleProjectConfiguration(teamType);

    const sampleProjectConfiguration = {
        ...config,
        columns: config.columns.map((column) => intl.formatMessage(column)),
        issueTypes: config.issueTypes.map((issueType) => ({
            ...issueType,
            name: intl.formatMessage(issueType.name)
        }))
    };

    const projectDetails = {
        ...KANBAN_PROJECT_DEFAULTS,
        defaultProjectName: intl.formatMessage(
            KANBAN_PROJECT_DEFAULTS.defaultProjectName
        )
    };

    return {
        teamType: teamTypeShorthand,
        sampleProjectConfiguration,
        projectDetails
    };
};
